
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/wm-contract-management",
      function () {
        return require("private-next-pages/solutions/wm-contract-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/wm-contract-management"])
      });
    }
  